var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ConversationColorHelp" },
    [
      _c(
        "a-tabs",
        { attrs: { animated: false, "default-active-key": "2" } },
        [
          _c(
            "a-tab-pane",
            { key: "2", attrs: { tab: _vm.$t("message.chatBar") } },
            [
              _c("div", { staticClass: "helpContainer" }, [
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#3699ff" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("message.unreadTitle")))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("message.unreadMsg")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#afafaf" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("message.visitorLeftTitle"))),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("message.visitorLeftChat"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#1bc5bd" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("message.activeChatTitle"))),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("message.activeChatMsg")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#ffa800" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("message.autoAssignedTitle"))),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("message.autoAssignMsg")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#f64e60" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("message.watchModeTitle"))),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("message.watchModeMsg")))]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: _vm.$t("message.chatList") } },
            [
              _c("div", { staticClass: "helpContainer" }, [
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#ffaaf0" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("message.lostChat")))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("message.repLostConn")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "helpContent" }, [
                  _c("div", {
                    staticClass: "colorBox",
                    staticStyle: { "background-color": "#a581bc" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "helpContentText" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("message.chatWidthDelay"))),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("message.repChatWidthDelay"))),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }